import {
    GET_CURRENT_USER,
    GET_CURRENT_USER_REQUEST,
    GET_CURRENT_USER_SUCCESS,
    GET_CURRENT_USER_FAILURE,
    LOGIN_SUCCESS,
    LOGOUT_SUCCESS
} from 'reducers/currentUser';

import {
    getCurrentUser,
    setAuthTokenData
} from 'backend-helpers/member'

import {
    saveToPersistent
} from 'reducers/authToken';

function getAuthTokenData(store) {
    let authTokenData = store.getState().authToken;
    if (authTokenData) {
        let {uid, token} = authTokenData;
        return (uid && token) ? {__uid: uid, __auth_token: token} : null;
    }

    return null;
}

const authTokenMiddleware = (store) => (next) => (action) => {
    // saving auth token to persistent storage
    if (action.type === LOGIN_SUCCESS) {
        saveToPersistent({uid: action.user.id, token: action.token});
        setAuthTokenData({uid: action.user.id, token: action.token});
    }

    // clearing saved auth token at persistent storage
    if (action.type === LOGOUT_SUCCESS) {
        saveToPersistent({uid: null, token: null});
        setAuthTokenData({uid: null, token: null});
    }

    // passing auth token to all restricted backend requests
    if (action.type === GET_CURRENT_USER) {
        let params = getAuthTokenData(store);

        return store.dispatch({
            types: [GET_CURRENT_USER_REQUEST, GET_CURRENT_USER_SUCCESS, GET_CURRENT_USER_FAILURE],
            promise: getCurrentUser(params)
        });
    }

    next(action);
};

export default authTokenMiddleware;


// WEBPACK FOOTER //
// ./src/middleware/authToken.js